import React from 'react';
import { Popover, Button, Position, Classes } from '@blueprintjs/core';
import { DateRangePicker } from "@blueprintjs/datetime";
import './styles.css';
import { dateRangePickerButton } from '../../styles';

class DateRangePickerComponent extends React.Component {

	state = {
		isOpen: false,
		disabled: true,
		dateRange: this.props.dateRange,
		dateRangeStr: null
	}

	isOpenCalendar = () => this.setState({ isOpen: true });


	handleDateChange = (dateRange) => {
		this.setState({ dateRange });
	}

	handleClick = () => {
		if (this.state.isOpen) {
			this.handleClose();
			return;
		}

		this.setState({
			isOpen: true,
		});
	}

	render() {

		const dateRangeStr = `${this.state.dateRange[0] !== undefined ? this.state.dateRange[0]?.toDateString(): 'None'}
		 / ${this.state.dateRange[1] !== undefined ? this.state.dateRange[1]?.toDateString() : 'None'}`;

		const minDate = new Date();
		minDate.setFullYear(minDate.getFullYear() - 5);

		const maxDate = new Date();
		maxDate.setFullYear(maxDate.getFullYear() + 5);

		return (
			<Popover onClose={this.handleClose}
				content={
					<DateRangePicker className={Classes.ELEVATION_1} contiguousCalendarMonths={false} shortcuts={false} value={this.state.dateRange}
						onChange={this.handleDateChange} minDate={minDate} maxDate={maxDate} allowSingleDayRange={true} />
				}
				position={Position.BOTTOM_RIGHT}
			>
				<Button icon="calendar" minimal={true} rightIcon="caret-down" style={dateRangePickerButton} onClick={this.handleClick}>
					{dateRangeStr}
				</Button>
			</Popover>

		);
	}

	handleClose = () => {
		this.setState({ isOpen: false });
		this.props.onChange(this.state.dateRange);
	}

}

export default DateRangePickerComponent;
